import { useCacheLocal } from "@/hooks/useCacheLocal";
import { createContext, ReactNode, useContext, useState } from "react";

type TConvertFilterCache = {
  page?: number | null;
  historyPage?: number | null;
};

type ConvertFilterCacheContextType = {
  convertFilterCache: TConvertFilterCache;
  setConvertFilterCache: (newFilter: TConvertFilterCache) => void;
};

const ConvertFilterCacheContext = createContext<ConvertFilterCacheContextType | undefined>(undefined);

export const ConvertFilterCacheProvider = ({ children }: { children: ReactNode }) => {
  const { getJSON, setJSON } = useCacheLocal("convert-filter");

  const [convertFilterCache, setConvertFilter] = useState<TConvertFilterCache>({
    ...getJSON(),
  });

  const setConvertFilterCache = (newFilter: TConvertFilterCache) => {
    setJSON(newFilter);
    setConvertFilter(newFilter);
  };

  return <ConvertFilterCacheContext.Provider value={{ convertFilterCache, setConvertFilterCache }}>{children}</ConvertFilterCacheContext.Provider>;
};

export const useConvertFilterCache = (): ConvertFilterCacheContextType => {
  const context = useContext(ConvertFilterCacheContext);
  if (!context) {
    throw new Error("useConvertFilterCache must be used within ConvertFilterCacheProvider");
  }
  return context;
};
